import { EClassification } from "./EClassification";

export const getClassificationByTestMode = (
  testMode: boolean
): EClassification =>
  testMode ? EClassification.TEST : EClassification.PRODUCTION;
